module.exports = __webpack_public_path__ + "static/media/cv.3ca68df0.pdf";